<template>
    <form class="d-flex flex-wrap gap-2 gap-column-3 width-max-700 mx-auto mb-4">
        <FormValidator
            :label="$t('firstName.label')"
            form-group
            :validator="$v.form.paymentData.firstName"
            v-slot="slotProps"
            label-class="pb-0"
            class="flex-grow-1 flex-basis-100 flex-basis-md-40"
        >
            <b-form-input v-model="form.paymentData.firstName" :disabled="loading" :state="slotProps.state" />
        </FormValidator>
        <FormValidator
            :label="$t('lastName.label')"
            form-group
            :validator="$v.form.paymentData.lastName"
            v-slot="slotProps"
            label-class="pb-0"
            class="flex-grow-1 flex-basis-100 flex-basis-md-40"
        >
            <b-form-input v-model="form.paymentData.lastName" :disabled="loading" :state="slotProps.state" />
        </FormValidator>
        <FormValidator
            :label="$t('street.label')"
            form-group
            :validator="$v.form.paymentData.street"
            v-slot="slotProps"
            label-class="pb-0"
            class="flex-grow-1 flex-basis-100 flex-basis-md-40"
        >
            <b-form-input v-model="form.paymentData.street" :disabled="loading" :state="slotProps.state" />
        </FormValidator>
        <div class="d-flex flex-wrap gap-2 gap-column-3 flex-grow-1 flex-basis-100 flex-basis-md-40">
            <FormValidator
                :label="$t('streetNumber.label')"
                form-group
                :validator="$v.form.paymentData.streetNumber"
                v-slot="slotProps"
                label-class="pb-0"
                class="flex-grow-1 flex-basis-100 flex-basis-md-40"
            >
                <b-form-input v-model="form.paymentData.streetNumber" :disabled="loading" :state="slotProps.state" />
            </FormValidator>
            <FormValidator
                :label="$t('apartmentNumber.label')"
                form-group
                :validator="$v.form.paymentData.apartmentNumber"
                v-slot="slotProps"
                label-class="pb-0"
                class="flex-grow-1 flex-basis-100 flex-basis-md-40"
            >
                <b-form-input v-model="form.paymentData.apartmentNumber" :disabled="loading" :state="slotProps.state" />
            </FormValidator>
        </div>
        <FormValidator
            :label="$t('city.label')"
            form-group
            :validator="$v.form.paymentData.city"
            v-slot="slotProps"
            label-class="pb-0"
            class="flex-grow-1 flex-basis-100 flex-basis-md-40"
        >
            <b-form-input v-model="form.paymentData.city" :disabled="loading" :state="slotProps.state" />
        </FormValidator>
        <FormValidator
            :label="$t('postcode.label')"
            form-group
            :validator="$v.form.paymentData.postcode"
            v-slot="slotProps"
            label-class="pb-0"
            class="flex-grow-1 flex-basis-100 flex-basis-md-40"
        >
            <b-form-input v-model="form.paymentData.postcode" :disabled="loading" :state="slotProps.state" :placeholder="$t('postcode.placeholder')" />
        </FormValidator>
        <FormValidator
            :label="$t('country.label')"
            form-group
            :validator="$v.form.paymentData.country"
            v-slot="slotProps"
            label-class="pb-0"
            class="flex-grow-1 flex-basis-100 flex-basis-md-40"
        >
            <b-form-select v-model="form.paymentData.country" :options="optionsCountry" :disabled="loading" :state="slotProps.state" />
        </FormValidator>
        <FormValidator
            :label="$t('bankAccount.label')"
            form-group
            :validator="$v.form.paymentData.bankAccount"
            v-slot="slotProps"
            label-class="pb-0"
            class="flex-grow-1 flex-basis-100 flex-basis-md-40"
        >
            <FormFieldIBAN v-model="form.paymentData.bankAccount" :disabled="loading" country-code-locked :state="slotProps.state" :placeholder="$t('bankAccount.placeholder')" />
        </FormValidator>
        <FormValidator form-group label-class="pb-0" class="flex-grow-1 flex-basis-100 flex-basis-md-40">
            <b-form-checkbox v-model="form.policies" :disabled="loading">
                {{ $t('terms.textBefore') }} <b-link class="text-body text-decoration-underline" target="_blank" :href="$t('terms.linkUrl')">{{ $t('terms.linkText') }}</b-link>{{ $t('terms.textAfter') }}
            </b-form-checkbox>
        </FormValidator>
        <div class="flex-grow-1 flex-basis-100 flex-basis-md-40 d-flex justify-content-md-end">
            <ButtonIcon class="w-100 w-md-auto ml-auto mb-auto wide" :disabled="!form.policies" :loading="loading" hide-label-while-loading @click="formSubmit">{{ $t('next') }}</ButtonIcon>
        </div>
    </form>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import cloneDeep from 'lodash/cloneDeep';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import FormValidator from '@/components/common/FormValidator.vue';
    import { deepMergeWithFilter } from '@/utils/util';
    import countryService from '@/services/countryService';
    import FormFieldIBAN from '@/components/common/FormFieldIBAN.vue';

    const FORM_DEFAULT_DATA = Object.freeze({
        policies: false,
        paymentData: {
            firstName: '',
            lastName: '',
            street: '',
            streetNumber: '',
            apartmentNumber: '',
            city: '',
            postcode: '',
            country: 'PL',
            bankAccount: '',
        },
    });

    export default {
        name: 'FormTipboxSettings',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
            FormFieldIBAN,
        },
        data() {
            return {
                form: cloneDeep(FORM_DEFAULT_DATA),
                requestTipboxSettings: this.$req('tipbox/TipboxSettings'),
            };
        },
        computed: {
            formValidations() {
                return {
                    form: {
                        policies: { required },
                        paymentData: {
                            firstName: { required },
                            lastName: { required },
                            street: { required },
                            streetNumber: { required },
                            apartmentNumber: {},
                            city: { required },
                            postcode: { required },
                            country: {},
                            bankAccount: { required: val => val.slice(2) },
                        },
                    },
                };
            },
            spacesUrlList() {
                return Object.values(this.$store.state.space.spaces).map(item => item.url);
            },
            tipboxSettings() {
                return this.requestTipboxSettings.getData() || {};
            },
            loading() {
                return this.requestTipboxSettings.getLoading();
            },
            optionsCountry() {
                return countryService.getCountryOptions();
            },
        },
        methods: {
            fetchTipboxSettings() {
                const params = { cache: false };
                return this.requestTipboxSettings.get(params);
            },
            initFormValues() {
                this.form = deepMergeWithFilter(FORM_DEFAULT_DATA, this.tipboxSettings || {});
            },
            formSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.requestTipboxSettings
                    .patch({ requestParams: this.form })
                    .then(async data => {
                        await this.fetchTipboxSettings().then(tipboxSettings => this.$store.commit('tipbox/setTipboxSettings', tipboxSettings));
                        this.$emit('next');
                    })
                    .catch(this.handleBackendValidations);
            },
        },
        async created() {
            await this.fetchTipboxSettings().catch(() => {});
            this.initFormValues();
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "firstName": {
        "label": "Imię",
        "placeholder": ""
    },
    "lastName": {
        "label": "Nazwisko",
        "placeholder": ""
    },
    "street": {
        "label": "Ulica",
        "placeholder": ""
    },
    "streetNumber": {
        "label": "Numer budynku",
        "placeholder": ""
    },
    "apartmentNumber": {
        "label": "Numer lokalu",
        "placeholder": ""
    },
    "city": {
        "label": "Miasto",
        "placeholder": ""
    },
    "postcode": {
        "label": "Kod pocztowy",
        "placeholder": "00-000"
    },
    "country": {
        "label": "Kraj",
        "placeholder": ""
    },
    "bankAccount": {
        "label": "Numer konta",
        "placeholder": "1122223333444455556666"
    },
    "terms": {
        "textBefore": "Przeczytałem i akceptuję",
        "linkText": "regulamin usługi tip.BOX",
        "linkUrl": "https://getbuybox.com/regulamin-uslugi-tip-box/",
        "textAfter": "."
    },
    "next": "Dalej"
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "firstName": {
        "label": "First Name",
        "placeholder": ""
    },
    "lastName": {
        "label": "Last Name",
        "placeholder": ""
    },
    "street": {
        "label": "Street",
        "placeholder": ""
    },
    "streetNumber": {
        "label": "Building Number",
        "placeholder": ""
    },
    "apartmentNumber": {
        "label": "Apartment Number",
        "placeholder": ""
    },
    "city": {
        "label": "City",
        "placeholder": ""
    },
    "postcode": {
        "label": "Postal Code",
        "placeholder": "00-000"
    },
    "country": {
        "label": "Country",
        "placeholder": ""
    },
    "bankAccount": {
        "label": "Account Number",
        "placeholder": "1122223333444455556666"
    },
    "terms": {
        "textBefore": "I have read and accept the",
        "linkText": "tip.BOX service terms and conditions",
        "linkUrl": "https://getbuybox.com/regulamin-uslugi-tip-box/",
        "textAfter": "."
    },
    "next": "Next"
}
</i18n>

